import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type IExportFilter } from '@backend/features/export/export.cross-platform';
import { environment } from 'apps/mba-cpr-survey-portal/src/environments/environment';

/**
 * TODO: Share with the server.
 * @author victor-shelepen
 */
export type IExportSampleSettings = {
  filter: IExportFilter;
  // formatter: 'json' | 'csv';
};

export type IExportMeasurementSettings = {
  filter: IExportFilter;
};

@Injectable()
export class ExportService {
  constructor(private http: HttpClient) {}

  startSampleExport(settings: IExportSampleSettings) {
    return this.http.post(`${environment.cprServiceApi}export/start/sample`, settings).toPromise();
  }

  startMeasurementExport(settings: IExportMeasurementSettings) {
    return this.http
      .post(`${environment.cprServiceApi}export/start/measurement`, settings)
      .toPromise();
  }

  startMonthlyAverageExport(settings: IExportMeasurementSettings) {
    return this.http
      .post(`${environment.cprServiceApi}export/start/monthly-average`, settings)
      .toPromise();
  }

  list() {
    return this.http.get(`${environment.cprServiceApi}export/list`).toPromise();
  }

  async downloadTaxons() {
    const data = await this.http
      .get(`${environment.cprServiceApi}export/download/taxons`, { responseType: 'text' })
      .toPromise();
    const blob = new Blob([data], { type: 'application/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'taxons.csv');
    document.body.appendChild(link);
    link.click();

    // link.remove();
    // window.URL.revokeObjectURL(url);
  }


  /**
   * TODO: It needs to be refactores.
   * 
   * @author victor-shelepen
   */
  async download(item) {
    const data = await this.http
      .get(`${environment.cprServiceApi}export/download/${item._id}`, { responseType: 'text' })
      .toPromise();
    const blob = new Blob([data], { type: 'application/text' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', item.key);
    document.body.appendChild(link);
    link.click();

    // link.remove();
    // window.URL.revokeObjectURL(url);
  }

  async getById(id: string) {
    return await this.http.get(`${environment.cprServiceApi}export/${id}`).toPromise();
  }
}
